import React from 'react'
import { useNewTranslation } from 'hooks/index'
import { Box, Text, Image } from 'rebass'

import { BatchSubmissionTaskState } from 'state/submissions'
import ButtonSecondary from 'components/Shared/Button/OldButton/ButtonSecondary'
import NotDoneTaskImg from 'icons/NotDoneTask.png'
import InProgressTaskImg from 'icons/InProgressTask.png'
import CompletedTaskImg from 'icons/CompletedTask.png'
import { theme } from 'theme'
import SubmittedAtDisplay from '../ProgressBlock/SubmittedAtDisplay'
import { useSelector } from 'react-redux'
import { selectSelectedCampaignSummary } from 'state/review'
import { ReviewedByDisplay } from '../ProgressBlock/ReviewedByDisplay'

interface BlockBaseProps {
    onClick?: any
}

const NotDoneBlock: React.FC<BlockBaseProps> = () => {
    const [newT] = useNewTranslation()

    return (
        <Box>
            <Image
                src={NotDoneTaskImg}
                sx={{
                    my: theme.spacing.xs,
                    objectPosition: 'center',
                    border: 'none',
                }}
            />
            <Text fontSize={2} fontWeight={500} pb={theme.spacing.xxxxs}>
                {newT('statusLabel.notDone')}
            </Text>
            <Text fontSize={1}>
                {newT('statusLabel.notDoneDescription', 'Waiting for Partiposter to submit their content')}
            </Text>
        </Box>
    )
}

const InProgressBlock: React.FC<BlockBaseProps> = () => {
    const [newT] = useNewTranslation()
    return (
        <Box>
            <Image
                src={InProgressTaskImg}
                sx={{
                    my: theme.spacing.xs,
                    objectPosition: 'center',
                    border: 'none',
                }}
            />
            <Text fontSize={2} fontWeight={500} pb={theme.spacing.xxxxs}>
                {newT('statusLabel.inProgress', 'In Progress')}
            </Text>
            <Text fontSize={1}>
                {newT(
                    'statusLabel.inProgressDescription',
                    'Waiting for Partiposter and your account manager to complete remaining steps',
                )}
            </Text>
        </Box>
    )
}

interface CompleteBlockProps {
    submissionTask: BatchSubmissionTaskState
    handleVerify: any
}

const CompletedBlock: React.FC<CompleteBlockProps> = ({ submissionTask, handleVerify }) => {
    const [newT] = useNewTranslation()
    const selectedCampaignSummary = useSelector(selectSelectedCampaignSummary)
    return (
        <>
            <Box>
                <Image
                    src={CompletedTaskImg}
                    sx={{
                        my: theme.spacing.xs,
                        objectPosition: 'center',
                        border: 'none',
                    }}
                />
                <Text fontSize={2} fontWeight={500} pb={theme.spacing.xxxxs}>
                    {newT('statusLabel.taskCompleted', 'Task Completed')}
                </Text>
                <ButtonSecondary
                    themeColor="dodgerBlue"
                    sx={{
                        borderRadius: 20,
                    }}
                    mt={theme.spacing.xs}
                    mb={theme.spacing.xxs}
                    px={2}
                    py={1}
                    onClick={handleVerify}
                >
                    {newT('button.viewDetail')}
                </ButtonSecondary>
            </Box>
            <Box my="auto" />
            {submissionTask?.current_progress && selectedCampaignSummary && (
                <>
                    <ReviewedByDisplay
                        submissionProgress={submissionTask.current_progress}
                        country={selectedCampaignSummary.country}
                    />
                    <SubmittedAtDisplay
                        submissionProgress={submissionTask.current_progress}
                        country={selectedCampaignSummary.country}
                    />
                </>
            )}
        </>
    )
}

export { NotDoneBlock, InProgressBlock, CompletedBlock }
